import script from "./login_form.vue?vue&type=script&lang=ts&setup=true"
export * from "./login_form.vue?vue&type=script&lang=ts&setup=true"

import "./login_form.vue?vue&type=style&index=0&id=21664652&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21664652"]])

export default __exports__